// interface State {
//   id: number;
//   name: string;
// }

import { SelectOption } from "../commonTypes";

// interface City {
//   id: number;
//   name: string;
// }

interface InitialState {
  jobRole: SelectOption[];
  currentUrl: string;
  feedbacks: SelectOption[];
  vendors: SelectOption[];
  auditTypes: SelectOption[];
  auditModes: SelectOption[];
  auditees: SelectOption[];
}

const initialState: InitialState = {
  jobRole: [],
  currentUrl: "",
  feedbacks: [],
  vendors: [],
  auditTypes: [],
  auditModes: [],
  auditees: [],
};

const SET_JOB_ROLE = "SET_JOB_ROLE";
const SET_CURRENT_URL = "SET_CURRENT_URL";
const SET_FEEDBACKS = "SET_FEEDBACKS";
const SET_VENDORS = "SET_VENDORS";
const SET_AUDIT_TYPES = "SET_AUDIT_TYPES";
const SET_AUDITEE = "SET_AUDITEE";
const SET_AUDIT_MODES = "SET_AUDIT_MODES";
const SET_AUDITEES = "SET_AUDIT_MODES";

export const RESET_STATE = "RESET_STATE";

export const setJobRoles = (jobRoles: SelectOption[]) => ({
  type: SET_JOB_ROLE,
  payload: jobRoles,
});

export const setFeedbacks = (feedbacks: SelectOption[]) => ({
  type: SET_FEEDBACKS,
  payload: feedbacks,
});
export const setVendors = (vendors: SelectOption[]) => ({
  type: SET_VENDORS,
  payload: vendors,
});

export const setCurrentUrl = (url: string) => ({
  type: SET_CURRENT_URL,
  payload: url,
});

export const setAuditTypes = (auditTypes: SelectOption[]) => ({
  type: SET_AUDIT_TYPES,
  payload: auditTypes,
});

export const setAuditee = (auditees: SelectOption[]) => ({
  type: SET_AUDITEE,
  payload: auditees,
});

export const setAuditModes = (auditModes: SelectOption[]) => ({
  type: SET_AUDIT_MODES,
  payload: auditModes,
});

export const resetState = () => ({
  type: RESET_STATE,
});

const staticDataReducer = (state = initialState, action: any): InitialState => {
  switch (action.type) {
    case SET_JOB_ROLE:
      return {
        ...state,
        jobRole: action.payload,
      };

    case SET_CURRENT_URL:
      return {
        ...state,
        currentUrl: action.payload,
      };

    case SET_FEEDBACKS:
      return {
        ...state,
        feedbacks: action.payload,
      };

    case SET_AUDIT_MODES:
      return {
        ...state,
        auditModes: action.payload,
      };

    case SET_AUDIT_TYPES:
      return {
        ...state,
        auditTypes: action.payload,
      };

    case SET_AUDITEES:
      return {
        ...state,
        auditees: action.payload,
      };

    case SET_VENDORS:
      return {
        ...state,
        vendors: action.payload,
      };
    case RESET_STATE:
      return initialState; // ✅ reset to initial state on logout
    default:
      return state;
  }
};

export default staticDataReducer;
